import { useFormik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { devActions } from "../../../redux/actions";
import { Flow } from "../flows";
import { FlowProvider, useFlowContext } from "../../contexts/Flow";
import { ReactFlowProvider } from "react-flow-renderer";
import { useSnackContext } from "../../contexts/Snack";

export const FileEditorOrquestador = (props) => {
  return (
    <FlowProvider>
      <ReactFlowProvider>
        <ChildFileEditorOrquestador {...props}/>
      </ReactFlowProvider>
    </FlowProvider>
  )
}

const ChildFileEditorOrquestador = ({tab, index, active}) => {

  const dispatch = useDispatch();
  const { flowData } = useFlowContext();
  const [ loaded, setLoaded ] = useState(false);

  useEffect(()=>{
    console.log("load FileEditor Orquestador", {tab, index, active, flowData, loaded})
  }, []);

  const formik = useFormik({
    initialValues: tab.data.metadata.item,
    onSubmit: (data) => {},
  })
  
  const handleFlowLoaded = () => {
    setLoaded(true);
  }
  
  const handleClose = (code) => {
  }

  useEffect(()=>{
    console.log("flowdata change", { flowData })
    if(loaded && flowData){
      dispatch(devActions.setChangedTab(index, true));
      dispatch(devActions.updateTabOrquestador(index, flowData.get()));
    }
  }, [flowData]);


  useEffect(()=>{
    console.log("FileEditorOrquestador formik values change", {values: formik.values})
  }, [formik.values])

  const handleInputChange = useCallback(({close = true}) => {
  }, [])

  const handleNodeDoubleClick = useCallback((event, node) => {
    console.log("node double click", {event, node});
    dispatch(devActions.openTabFromOrquestador(
      node.data.idPrimitiva || node.data.idTemplate,
      node.data.idPrimitiva 
        ? "primitiva"
        : node.data.idTemplate 
          ? "template"
          : null
    ));
  }, []);

  return (
    <>
      {!tab.data.metadata.isNewFile &&
        <Flow 
          formik={formik} 
          name="flow"
          onLoad={handleFlowLoaded} 
          onSave={handleInputChange} 
          onClose={handleClose}
          sxAddNodeIcon={sxAddNodeIcon}
          sxCopyNodesIcon={sxCopyNodesIcon}
          sxPasteNodesIcon={sxPasteNodesIcon}
          sxPasteSpecialNodesIcon={sxPasteSpecialNodesIcon}
          sxReloadTypes={sxReloadTypes}
          containerStyle={{height: "100%", backgroundColor: "rgb(93 93 93)", position: "relative"}}
          onNodeDoubleClick={handleNodeDoubleClick}
          /*containerStyle={{height: "100%", backgroundColor: "#272822", position: "relative"}}*/
        />
      }
      {tab.data.metadata.isNewFile &&
        <div style={{
          height: "100%",
          backgroundColor: "rgb(93, 93, 93)",
          width: "100%",
          alignItems: "center",
          alignContent: "center",
          textAlign: "center",
          color: "white",
        }}>La edición del flujo estará disponible cuando guarde el orquestador</div>
      }
    </>
  )

}

const sxAddNodeIcon = { position: 'absolute', width: 44, height: 44, top: 10, left: 10, zIndex: 9000 };
const sxCopyNodesIcon = { position: 'absolute', width: 44, height: 44, top: 10, left: 64, zIndex: 9000 };
const sxPasteNodesIcon = { position: 'absolute', width: 44, height: 44, top: 10, left: 118, zIndex: 9000 };
const sxPasteSpecialNodesIcon = { position: 'absolute', width: 44, height: 44, top: 10, left: 172, zIndex: 9000 };
const sxReloadTypes = { position: 'absolute', width: 44, height: 44, top: 10, left: 226, zIndex: 9000 };
